import * as documentViewerReducer from "../reducers/documentViewerReducer";

export const {
  getDocumentPath,
  getDocumentName,
  getIsDocumentViewerOpen,
  getProps,
  getLocation,
  getVersionId,
} = documentViewerReducer;
